// Same enum on backend
export enum FeedbackType {
  MarketActivity = 1,
  Rieltors = 2,
  Objects = 3,
  IosAppReview = 4,
  AndroidAppReview = 5,
}
